import FrontCover from '@/api/administrator/front-cover'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return FrontCover.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, { id, data }) {
    if (id > 0) {
      return FrontCover.update(id, data)
    }
    return FrontCover.store(data)
  },
  destroy(context, id) {
    return FrontCover.destroy(id)
  },

  fetchFrontCover(context) {
    return FrontCover.getFrontCover()
  }
}
